import { render, staticRenderFns } from "./DropSelectedFile.vue?vue&type=template&id=2a5c461f&scoped=true"
import script from "./DropSelectedFile.vue?vue&type=script&lang=js"
export * from "./DropSelectedFile.vue?vue&type=script&lang=js"
import style0 from "./DropSelectedFile.vue?vue&type=style&index=0&id=2a5c461f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c461f",
  null
  
)

export default component.exports